import React, { useMemo } from 'react';
import './karaoke.css';

// Built-in animated concert stages (CSS only). theme: purple_stage | blue_concert | golden_spotlight
export const StageBackground = ({ theme = 'purple_stage' }) => {
  const sparks = useMemo(() => Array.from({ length: 34 }, (_, i) => ({
    left: `${(i * 37) % 100}%`, bottom: `${-5 - (i % 5) * 4}%`, size: 3 + (i % 4) * 2,
    dur: 7 + (i % 6) * 1.7, delay: -(i * 0.9),
  })), []);
  return (
    <div className={`kstage kstage--${theme}`} aria-hidden="true" data-testid={`karaoke-stage-${theme}`}>
      <div className="kstage__haze" />
      <div className="kstage__lights">{Array.from({ length: 9 }, (_, i) => <span key={i} style={{ animationDelay: `${i * 0.27}s` }} />)}</div>
      {['b1', 'b2', 'b3', 'b4', 'b5'].map((b) => <div key={b} className={`kstage__beam ${b}`} />)}
      {theme === 'blue_concert' && ['l1', 'l2', 'l3', 'l4'].map((l, i) => <div key={l} className={`kstage__laser ${l}`} style={{ top: `${12 + i * 7}%`, left: i % 2 ? '8%' : '92%' }} />)}
      {theme === 'golden_spotlight' && sparks.map((s, i) => (
        <span key={i} className="kstage__spark" style={{ left: s.left, bottom: s.bottom, width: s.size, height: s.size, animationDuration: `${s.dur}s`, animationDelay: `${s.delay}s` }} />
      ))}
      <div className="kstage__floor" />
      <div className="kstage__vignette" />
    </div>
  );
};

export default StageBackground;
